// extracted by mini-css-extract-plugin
export default {"warning":"Warning_warning__yJQcd","warning-red":"Warning_warning-red__ai96v","warning-yellow":"Warning_warning-yellow__SrrEb"};